// Returns target only if it is a same-site relative path; otherwise the fallback (never an external site)
export const safeRedirect = (target, fallback = '/dashboard') => {
  if (!target || typeof target !== 'string') return fallback;
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u0020\u007f\\]/.test(target) || !target.startsWith('/') || target.startsWith('//')) return fallback;
  try {
    const url = new URL(target, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    return url.pathname + url.search + url.hash;
  } catch (e) {
    return fallback;
  }
};
